import { FaTicketAlt, FaUsers,FaTachometerAlt, FaClipboardList, FaDatabase, FaCogs } from 'react-icons/fa';
import { FaPeopleGroup } from "react-icons/fa6";
import { FaPeopleCarryBox } from "react-icons/fa6";
import { MdOutlineSupportAgent } from "react-icons/md";

export const menuData = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: <FaTachometerAlt />,
    access_role_ids:[1,2,3,4,5]
  },
  {
    label: "Manage Sales Team",
    path: "/salesman-list",
    icon: <FaUsers />,
    access_role_ids:[1,2]
  },
  {
    label: "Manage Agents",
    path: "/manage_agents",
    icon: <MdOutlineSupportAgent />,
    access_role_ids:[1,2]
  },
  
  {
    label: "Subscribers",
    path: "/subscribers",
    icon: <FaPeopleCarryBox />,
    access_role_ids:[1,2,3,4]
  },
  {
    label: "Manage Customers",
    path: "/manage_customers",
    icon: <FaPeopleGroup />,
    access_role_ids:[1,2,3,4]
  },
  {
    label: "Enquires",
    path: "/enquires",
    icon: <FaClipboardList />,
    access_role_ids:[1,2,3]
  },
  {
    label: "Leads",
    path: "/leads",
    icon: <FaDatabase />,
    access_role_ids:[1,2,3,4]
  },
  {
    label: "My Loan Applicatons",
    path: "/loan-applications",
    icon: <FaDatabase />,
    access_role_ids:[5]
  },
  {
    label: "My Subscriptions",
    path: "/my-subscriptions",
    icon: <FaDatabase />,
    access_role_ids:[5]
  },
  
  // {
  //   label: "Loans",
  //   path: "/loans",
  //   icon: <FaDatabase />,
  // },
  {
    label: "Service Configuration",
    path: "/service_configuration",
    icon: <FaCogs />,
    access_role_ids:[1,2]
  },
  {
    label: "Support tickets",
    path: "/support-tickets",
    icon: <FaTicketAlt />,
    access_role_ids:[1,2,3,4,5,6]
  }
];
